import Strategy from './Strategy'

import { I18nStrategy, Locale } from '../model'

class SingleLocaleStrategy extends Strategy implements I18nStrategy {
  locale: Locale

  constructor(locale: Locale) {
    super()
    this.locale = locale
  }

  getLocale() {
    return this.locale
  }

  setLocale(locale: Locale) {
    this.locale = locale
    this.update()
  }
}

export default SingleLocaleStrategy
